
























import { Component, Vue } from 'vue-property-decorator'
import BooksList from '@/components/BooksList.vue'
import { RandomSubjects } from '@/model/RandomSubjects'

@Component({
  components: {
    BooksList,
  }
})

export default class Home extends Vue {
  public category = 'surfing'
  public booksListKey = 0
  private categories = RandomSubjects

  changeCategory(event: Event): void {
    this.category = (event.target as HTMLSelectElement).value
    console.log(event)
    console.log(event.target)
    this.booksListKey += 1
  }
}
